// extracted by mini-css-extract-plugin
export default {"title":"CTABanner_title__869cx","pitstopGif":"CTABanner_pitstopGif__prCIw"};